"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = require("styled-components");

// The 'x' used to close containers, standard size is built for modals
// the 'small' prop should be used for snackbars and flash messages.
var closeButton = (0, _styledComponents.css)(["font-size:", ";font-weight:normal;color:", ";height:", ";width:", ";line-height:", ";&:before{content:'\\002715';font-family:", ";cursor:pointer;}&:hover{&:before{color:", ";}}"], function (props) {
  return props.small && props.theme.closeButtonSizeSm || props.theme.closeButtonSize;
}, function (props) {
  return props.white && props.theme.iconColorWhite || props.theme.closeButtonColor;
}, function (props) {
  return props.small && props.theme.closeButtonSizeSm || '72px';
}, function (props) {
  return props.small && props.theme.closeButtonSizeSm || '72px';
}, function (props) {
  return props.small && props.theme.closeButtonSizeSm || '72px';
}, function (props) {
  return props.theme.fontFamilyDefault;
}, function (props) {
  return props.white && props.theme.fontColorLight || props.theme.closeButtonColorHover;
});
var _default = closeButton;
exports["default"] = _default;